(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
var bootstrapping = require('../../sdk/bootstrapping.js');
var playerClient = require('../player/client.js');
var dom = require('../../sdk/dom.js');
var log = require('../../sdk/log.js');
log.scope = { app: 'sdk.allinone', webcastId: bootstrapping.query.id };

var expanded = false;
var elements = {
    player: document.getElementById('player'),
    chat: document.getElementById('chat'),
    expandBtn: document.getElementById('expand'),
}

dom.hide(elements.expandBtn);

var player = playerClient.create(toPlayerOptions(bootstrapping.query));

elements.player.insertBefore(player.element, elements.player.firstChild);
elements.chat.appendChild(player.createChat());

player.on('chat:ready', function () {
    document.body.classList.add('chat-expanded');
    document.body.classList.add('chat');
    dom.fadeIn(elements.expandBtn);
    expanded = true;
}); 


elements.expandBtn.addEventListener('click', function (e) {
    document.body.classList[expanded ? 'remove' : 'add']('chat-expanded');
    expanded = !expanded;
});


function toPlayerOptions(query) {
    var options = {};

    for (var key in query) {
        switch (key) {
            case 'display':
            case 'emit':
                break;
            case 'customBtnColor':
                options.customBtnColor = query.customBtnColor.default + ',' + query.customBtnColor.disabled;
                break;
            default:
                options[key] = query[key];
                break;
        }
    }
    return options;
}
},{"../../sdk/bootstrapping.js":6,"../../sdk/dom.js":10,"../../sdk/log.js":15,"../player/client.js":3}],2:[function(require,module,exports){
var CIC = require('../../sdk/CrossIframeCommunication.js');
var config = require('../../sdk/config.js');

module.exports = IframeWrapper;

var url = {
    playerIFrame: config.appDomain + '/sdk/player/',
    p2pPlayerIFrame: config.appDomain + '/sdk/p2pplayer/',
    chatIFrame: config.appDomain + '/sdk/chat/',
};
var validQueryProperties = [
    'id',
    'offsets',
    'embed',
    'autoplay',
    'start',
    'repeat',
    'display',
    'identificationToken',
    'dvr',
    'language',
    'customBtnColor',
    'customVideoAndSlideBackgroundColor',
    'newWindow',
    'debug',
    'emit',
    'textTrack',
    'skipWebcastLink',
    'pipeline',
    'source',
];

function IframeWrapper(options) {
    var _this = this;
    options.id = options.id.replace('/', '_');

    if (options.version < 2) {
        if (options.display !== undefined) {
            if (isNaN(options.display)) options.display = 0;
            options.display += 16 + 32 + 64;
        }
    }

    var cic = new CIC(options.id);



    this.element = options.element || createPlayerIframe();
    this.on = on;
    this.emit = cic.emit;
    this.subscribeIframe = cic.subscribeIframe;
    this.seek = seek;
    this.createChat = createChat;
    this.destroy = destroy;
    this.element.src = createPlayerUrl();

    this.playPause = {
        state: 'unknown',
        toggle: function () {
            _this.emit(_this.playPause.state == _this.playPause.states.playing ? 'pause' : 'play');
        },
    };

    cic.subscribeIframe(this.element);

    cic.on('playpause.state:change', function (e) {
        _this.playPause.state = e.state;
        _this.playPause.states = e.states;
    });

    function createChat() {
        var chat = createChatIframe();
        cic.subscribeIframe(chat);
        return chat;
    }

    function on(event, callback) {

        if (options.version < 2) {
            return onv1(event, function (e) {
                callback(translateEvent(e));
            });
        }

        return cic.on(event, function (e) {
            callback(translateEvent(e));
        });
    }

    function translateEvent(e) {
        if (e && e.event) {
            if (e.event.intent == 'index.index:activate') e.event.intent = 'topics.topic:activate';
            if (e.event.intent == 'index.index:deactivate') e.event.intent = 'topics.topic:deactivate';
            if (e.event.intent == 'speakers.hide:deactivate') e.event.intent = 'speakers.speaker:deactivate';
            if (e.event.intent == 'dcnspeakers.speaker:activate') e.event.intent = 'speakers.speaker:activate';
            if (e.event.intent == 'dcnspeakers.speaker:deactivate') e.event.intent = 'speakers.speaker:deactivate';
            if (e.event.intent == 'dcnspeakers.hide:deactivate') e.event.intent = 'speakers.speaker:deactivate';
        }
        return e;
    }

    function onv1(event, callback) {
        switch (event) {
            case 'cwc.sdk.player.resource.create':
                return cic.on('resource:create', callback);
            case 'cwc.sdk.player.resource.properties.change':
                return cic.on('resource.state:change', function (e) {
                    callback({
                        resource: e.resource,
                        properties: {
                            isActive: e.isActive,
                        },
                        view: 'current',
                    });
                });
        }
    }




    function createPlayerIframe() {
        var element = options.element || document.createElement('iframe');
        element.src = createPlayerUrl();
        element.style.width = '100%';
        element.style.height = '100%';
        element.style.border = '0';
        element.id = options.id;
        element.setAttribute('allowfullscreen', 'true');
        element.setAttribute('webkitallowfullscreen', 'true');
        element.setAttribute('mozallowfullscreen', 'true');
        element.setAttribute('oallowfullscreen', 'true');
        element.setAttribute('msallowfullscreen', 'true');
        return element;
    }

    function createChatIframe() {
        var element = document.createElement('iframe');
        element.style.width = '100%';
        element.style.height = '100%';
        element.style.border = '0';
        element.src = createChatUrl();

        return element;
    }

    function seek(options) {
        cic.postMessage(_this.element.contentWindow, 'seek', options);
    }

    function createPlayerUrl() {

        var string = options.p2p == undefined ? options.playerIFrame || url.playerIFrame : options.p2pPlayerIFrame || url.p2pPlayerIFrame;

        var first = true;
        var hasOptions = false;
        for (var key in options) {

            if (validQueryProperties.indexOf(key) == -1) continue;
            if ((key == 'autoplay' || key == 'repeat') && !options[key]) continue;

            hasOptions = true;

            string += first ? '?' : '&';
            string += key;

            switch (key) {
                case 'offsets':
                    string += '=' + getOffsets(options[key]);
                    break;
                case 'id':
                    string += '=' + encodeURIComponent(options[key].replace('/', '_'));
                    break;
                case 'autoplay':
                case 'repeat':
                case 'debug':
                case 'skipWebcastLink':
                    break;
                default:
                    string += '=' + options[key];
                    break;
            }

            first = false;
        }

        first = true;
        var query = getQueryParameters();
        for (var key in query) {
            if (key.indexOf('utm') == 0) {
                string += first && !hasOptions ? '?' : '&';
                string += key + '=' + query[key];
                first = false;
            }
        }

        return string;
    }

    function getOffsets(offsets) {
        var first = true;
        var string = '';
        for (var i = 0, length = offsets.length; i < length; i++) {
            if (!first) {
                string += ','
            }

            string += offsets[i];
            first = false;
        }
        return string;
    }

    function destroy() {
        cic.destroy();
    }

    function createChatUrl() {
        return url.chatIFrame
            + '?id=' + options.id;
    }
}

function getQueryParameters(str) {
    return (str || document.location.search).replace(/(^\?)/, '').split("&").map(function (n) { return n = n.split("="), this[n[0]] = decodeURIComponent(n[1]), this }.bind({}))[0];
}
},{"../../sdk/CrossIframeCommunication.js":4,"../../sdk/config.js":8}],3:[function(require,module,exports){
var IframeWrapper = require('./IFrameWrapper.js');
var displayOptions = require('../../sdk/player/displayOptions.js');

window.cwc = window.cwc || {};
window.cwc.sdk = window.cwc.sdk || {};
window.cwc.sdk.player = window.cwc.sdk.player || {};

window.cwc.sdk.player.client = {
    createPlayer: function (options) {
        options.version = 2;
        return createPlayer(options);
    },
    displayOptions: displayOptions,
}

window.cwc.iframe = window.cwc.iframe || {};
window.cwc.iframe.player = window.cwc.iframe.player || {};
window.cwc.iframe.player.client = {
    create: function (options) {
        options.version = 1;
        return createPlayer(options);
    },
    displayOptions: displayOptions,
}

function createPlayer(options) {
    return new IframeWrapper(options);
}

module.exports = {
    create: function (options) {
        options.version = 2;
        return createPlayer(options);
    }
}
},{"../../sdk/player/displayOptions.js":17,"./IFrameWrapper.js":2}],4:[function(require,module,exports){
var EventEmitter = require('./EventEmitter.js');
var guid = require('./guid.js');

module.exports = CrossIframeCommunication;


function CrossIframeCommunication(key) {
    var _this = this;
    var eventEmitter = new EventEmitter(true);
    var iFrames = [];
    var parents = [];

    this.id = guid.v4();
    this.postMessage = postMessage;
    this.emit = emit;
    this.on = eventEmitter.on;
    this.one = eventEmitter.on;
    this.subscribeIframe = subscribeIframe;
    this.destroy = destroy;

    function postMessage(target, event, data) {
        var message = {
            sender: _this.id,
            key: key,
            event: event,
            data: data,
        };

        try {
            if (target) target.postMessage(message, '*');
        } catch (e) {
            console.log(e, message);
        }
    }

    function emit(event, data) {

        for (var i = 0, length = iFrames.length; i < length; i++) {
            postMessage(iFrames[i].contentWindow, event, data);
        }

        for (var i = 0, length = parents.length; i < length; i++) {
            postMessage(parents[i], event, data);
        }

        return eventEmitter.emit(event, data);
    }

    window.addEventListener('message', onMessage);

    postMessage(window.opener || window.parent, 'ready');

    function onMessage(e) {
        try {
            var obj = e.data;

            if (!obj.key || obj.key == key && obj.sender != _this.id) {
                emit(obj.event, obj.data);
            }
        } catch (e) {
            console.error(e);
            //nomnomnom
        }
    }

    function subscribeIframe(element) {
        iFrames.push(element);
    }

    function subscribeParent(element) {
        parents.push(element);
    }

    function destroy() {
        window.removeEventListener('message', onMessage);
        iFrames = null;
        parents = null;
        eventEmitter = null;
    }
}


},{"./EventEmitter.js":5,"./guid.js":11}],5:[function(require,module,exports){
/**
@class
@alias cwc.sdk.EventEmitter
@description emit events
@constructor
@property {object} events list of registered events
*/
function EventEmitter(storeEvents) {
    var _this = this;

    this.events = {};
    this.callbacks = {};
    this.emit = emit;
    this.on = on;
    this.one = one;
    this.destroy = destroy;

    /**
    @method
    @alias cwc.sdk.EventEmitter.emit
    @description emit an event
    @param {string} event name of event
    @param {object} data will be passed to event listeners
    @return {array} results
    */
    function emit(event, data) {

        if (storeEvents) {
            var events = _this.events[event];
            if (!events) {
                events = [];
                _this.events[event] = events;
            }
            events.push(data);
        }

        var callbacks = _this.callbacks[event];
        var results = [];
        if (callbacks) {
            for (var i = callbacks.length - 1; i >= 0; --i) {
                var callback = callbacks[i];
                results.push(callback(data));
                if (callback.once) {
                    callback.remove();
                }
            }
        }
        return results;
    }

    /**
    @method
    @alias cwc.sdk.EventEmitter.on
    @description listen to an event
    @param {string} event name of event
    @param {function} callback will be called when an event is emitted
    @return {function} cancelToken calling this function will unregister this listener
    */
    function on(event, callback, once) {
        var callbacks = _this.callbacks[event];
        if (!callbacks) {
            callbacks = [];
            _this.callbacks[event] = callbacks;
        }

        callbacks.push(callback);

        callback.once = once;
        callback.remove = function () {
            var index = callbacks.indexOf(callback);
            if (index > -1) callbacks.splice(index, 1);
        }

        if (storeEvents) {
            var events = _this.events[event];
            if (events) {
                for (var i = 0, length = events.length; i < length; i++) {
                    callback(events[i]);
                    if (once) {
                        callback.remove();
                        break;
                    }
                }
            }
        }

        return callback.remove;
    }

    /**
    @method
    @alias cwc.sdk.EventEmitter.one
    @description listen to an event once
    @param {string} event name of event
    @param {function} callback will be called when an event is emitted (one time only)
    */
    function one(event, callback) {
        return on(event, callback, true);
    }

    function destroy() {
        _this.events = {};
    }
}


module.exports = EventEmitter;
},{}],6:[function(require,module,exports){
var browserSniffing = require('./browserSniffing.js');
var log = require('./log.js');
var pipelines = require('./pipelines.js');

var minFontSize = 8;
var baseFontSize = 28;
var baseScreenWidth = 1080 / 9;
var fontRatio = (baseFontSize - minFontSize) / baseScreenWidth;

var params = getQueryParameters();
var query = getOptions(params);
var language = query.language || getLanguage();

if (query.debug) {
    log.hijackConsole();
}

var api = {
    registerFontSizeListener: registerFontSizeListener,
    query: query,
    language: language,
    getDisplay: function (displayOptions) {
        return getDisplayOptions(params.display, displayOptions);
    }
}

module.exports = api;

document.body.onload = function () {
    var el = document.getElementById('ConnectiveDocSignExtentionInstalled');
    if (el) el.remove();
}


function getQueryParameters(str) {
    return (str || document.location.search).replace(/(^\?)/, '').split("&").map(function (n) { return n = n.split("="), this[n[0]] = decodeURIComponent(n[1]), this }.bind({}))[0];
}

function getLanguage() {

    var lang = window.navigator.languages ? window.navigator.languages[0] : null;
    lang = lang || window.navigator.language || window.navigator.browserLanguage || window.navigator.userLanguage;
    if (lang.indexOf('-') !== -1) lang = lang.split('-')[0];
    if (lang.indexOf('_') !== -1) lang = lang.split('_')[0];
    return lang;
}

function registerFontSizeListener() {

    setFontSize();

    window.addEventListener('resize', setFontSize);
}

function setFontSize() {
    var fontSize;
    var width = window.innerWidth / 16;
    var height = window.innerHeight / 9;

    if (width > height) {
        fontSize = height * fontRatio;
    } else {
        fontSize = width * fontRatio;
    }

    document.body.style.fontSize = Math.ceil(minFontSize + fontSize) + 'px';
}

function getOptions(query) {
    var options = query;

    if (options.debug !== undefined) {
        options.debug = true;
    }

    if (options.offsets) {
        options.offsets = options.offsets.split(',');
    }

    if (options.start) {
        options.start = parseInt(options.start);
    }

    if (options.autoplay !== undefined) {
        options.autoplay = true;
    }

    if (options.repeat !== undefined) {
        options.repeat = true;
    }

    if (options.skipWebcastLink !== undefined) {
        options.skipWebcastLink = true;
    }

    if (!(options.pipeline && pipelines[options.pipeline])) {
        options.pipeline = undefined;
    }

    if (options.transparent !== undefined) {
        options.transparent = true;
    }

    if (options.autosubmit !== undefined) {
        options.autosubmit = true;
    }

    if (options.liveSubtitleDelay !== undefined) {
        options.liveSubtitleDelay = parseFloat(options.liveSubtitleDelay);
    }

    var el = document.createElement('style');

    if (options.customBtnColor) {
        options.customBtnColor = options.customBtnColor.split(',');
        options.customBtnColor = {
            default: options.customBtnColor[0],
            disabled: options.customBtnColor[1],
        }

        el.innerHTML += '.btn-bright { background-color: #' + options.customBtnColor.default + '; } '
        el.innerHTML += '.btn-bright:disabled { background-color: #' + options.customBtnColor.disabled + '; } '
    }

    if (options.customVideoAndSlideBackgroundColor) {
        el.innerHTML += '.video.videoandslide { background-color: #' + options.customVideoAndSlideBackgroundColor.replace('#', '') + '; }';
    }

    document.head.appendChild(el);

    if (options.p2p !== undefined || window.location.href.indexOf('/p2pplayer') > -1) {
        options.p2p = true;
    }

    if (options.p2pProxy !== undefined && (browserSniffing.IE || browserSniffing.Edge)) {
        options.p2pProxy = true;
    }

    if (options.cic) {
        var cic = options.cic.split(',');
        options.cic = {};
        for (var i = 0; i < cic.length; i++) {
            options.cic[cic[i]] = true;
        }
    }

    var emit = {};
    if (options.emit) {
        var emit = options.emit.split(',');
        options.emit = {};
        for (var i = 0; i < emit.length; i++) {
            options.emit[emit[i]] = true;
        }
    } else {
        options.emit = {};
    }

    options.dvr = options.dvr == undefined ? true : options.dvr == "true";
    options.scrubbing = options.scrubbing == undefined ? true : options.scrubbing == "true";
    options.newWindow = browserSniffing.webView ? false : options.newWindow == undefined ? true : options.newWindow == "true";

    if (options.embed) {
        options.embed = options.embed.split(',');
    }

    return options;
}

function getDisplayOptions(options, displayOptions) {
    var display = {}

    if (options === undefined) {
        options = displayOptions.all;
    }
    options = parseInt(options);

    for (var key in displayOptions) {
        display[key] = !!((displayOptions[key] & options) == displayOptions[key]);
    }

    return display;
}
},{"./browserSniffing.js":7,"./log.js":15,"./pipelines.js":16}],7:[function(require,module,exports){
(function (global){
var USER_AGENT = navigator.userAgent;
var IPAD = /iPad/i.test(USER_AGENT);
var IPHONE = /iPhone/i.test(USER_AGENT) && !IPAD;
var IPOD = /iPod/i.test(USER_AGENT);
var IOS = IPHONE || IPAD || IPOD;
var MAC = navigator.platform.toUpperCase().indexOf('MAC') >= 0;
var EDGE = navigator.appVersion.indexOf('Edge') > -1 || navigator.appVersion.indexOf('Edg') > -1;
var EDGECHROMIUM = navigator.appVersion.indexOf('Edg/') > -1;
var IE = navigator.appVersion.indexOf('MSIE') > -1 || navigator.appVersion.indexOf('Trident') > -1;
var WINDOWSPHONE = navigator.appVersion.indexOf('Windows Phone') > -1;
var SAFARI = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
var MOBILE = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(navigator.userAgent || navigator.vendor || window.opera) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test((navigator.userAgent || navigator.vendor || window.opera).substr(0, 4));
var CHROMEIOS = /CriOS/i.test(USER_AGENT);

var ua = USER_AGENT;
var os = _detectOS(ua);
var browser = _detectBrowser(ua);
var browserVersion = _detectBrowserVersion(ua, browser);
var webView = _isWebView(ua, os, browser, browserVersion, {});
var ios17 = SAFARI && parseInt(browserVersion.split('.')[0]) >= 17


var api = {
    IOS: IOS,
    IPad: IPAD,
    IPhone: IPHONE,
    IPod: IPOD,
    MAC: MAC,
    Edge: EDGE,
    EdgeChromium: EDGECHROMIUM,
    IE: IE,
    WindowsPhone: WINDOWSPHONE,
    Safari: SAFARI,
    mobile: MOBILE,
    ChromeIOS: CHROMEIOS,
    webView: webView,
    os: os,
    osVersion: getIOSVersion(),
    browser: browser,
    browserVersion: browserVersion,
    ios17: ios17
}

module.exports = api;

function _detectOS(ua) {
    switch (true) {
        case /Android/.test(ua): return "Android";
        case /iPhone|iPad|iPod/.test(ua): return "iOS";
        case /Windows/.test(ua): return "Windows";
        case /Mac OS X/.test(ua): return "Mac";
        case /CrOS/.test(ua): return "Chrome OS";
        case /Firefox/.test(ua): return "Firefox OS";
    }
    return "";
}

function _detectBrowser(ua) {
    var android = /Android/.test(ua);

    switch (true) {
        case /CriOS/.test(ua): return "Chrome for iOS"; // https://developer.chrome.com/multidevice/user-agent
        case /Edge/.test(ua): return "Edge";
        case android && /Silk\//.test(ua): return "Silk"; // Kidle Silk browser
        case /Chrome/.test(ua): return "Chrome";
        case /Firefox/.test(ua): return "Firefox";
        case android: return "AOSP"; // AOSP stock browser
        case /MSIE|Trident/.test(ua): return "IE";
        case /Safari\//.test(ua): return "Safari";
        case /AppleWebKit/.test(ua): return "WebKit";
    }
    return "";
}

function _detectBrowserVersion(ua, browser) {
    switch (browser) {
        case "Chrome for iOS": return _getVersion(ua, "CriOS/");
        case "Edge": return _getVersion(ua, "Edge/");
        case "Chrome": return _getVersion(ua, "Chrome/");
        case "Firefox": return _getVersion(ua, "Firefox/");
        case "Silk": return _getVersion(ua, "Silk/");
        case "AOSP": return _getVersion(ua, "Version/");
        case "IE": return /IEMobile/.test(ua) ? _getVersion(ua, "IEMobile/")
            : /MSIE/.test(ua) ? _getVersion(ua, "MSIE ") // IE 10
                : _getVersion(ua, "rv:");  // IE 11
        case "Safari": return _getVersion(ua, "Version/");
        case "WebKit": return _getVersion(ua, "WebKit/");
    }
    return "0.0.0";
}

function _isWebView(ua, os, browser, version, options) { // @ret Boolean - is WebView
    switch (os + browser) {
        case "iOSSafari": return false;
        case "iOSWebKit": return _isWebView_iOS(options);
        case "AndroidAOSP": return false; // can not accurately detect
        case "AndroidChrome": return parseFloat(version) >= 42 ? /; wv/.test(ua)
            : /\d{2}\.0\.0/.test(version) ? true // 40.0.0, 37.0.0, 36.0.0, 33.0.0, 30.0.0
                : _isWebView_Android(options);
    }
    return false;
}

function _isWebView_iOS(options) { // @arg Object - { WEB_VIEW }
    // @ret Boolean
    // Chrome 15++, Safari 5.1++, IE11, Edge, Firefox10++
    // Android 5.0 ChromeWebView 30: webkitFullscreenEnabled === false
    // Android 5.0 ChromeWebView 33: webkitFullscreenEnabled === false
    // Android 5.0 ChromeWebView 36: webkitFullscreenEnabled === false
    // Android 5.0 ChromeWebView 37: webkitFullscreenEnabled === false
    // Android 5.0 ChromeWebView 40: webkitFullscreenEnabled === false
    // Android 5.0 ChromeWebView 42: webkitFullscreenEnabled === ?
    // Android 5.0 ChromeWebView 44: webkitFullscreenEnabled === true
    var document = (global["document"] || {});

    if ("WEB_VIEW" in options) {
        return options["WEB_VIEW"];
    }
    return !("fullscreenEnabled" in document ||
        "webkitFullscreenEnabled" in document || false);
}

function _isWebView_Android(options) { // @arg Object - { WEB_VIEW }
    // Chrome 8++
    // Android 5.0 ChromeWebView 30: webkitRequestFileSystem === false
    // Android 5.0 ChromeWebView 33: webkitRequestFileSystem === false
    // Android 5.0 ChromeWebView 36: webkitRequestFileSystem === false
    // Android 5.0 ChromeWebView 37: webkitRequestFileSystem === false
    // Android 5.0 ChromeWebView 40: webkitRequestFileSystem === false
    // Android 5.0 ChromeWebView 42: webkitRequestFileSystem === false
    // Android 5.0 ChromeWebView 44: webkitRequestFileSystem === false
    if ("WEB_VIEW" in options) {
        return options["WEB_VIEW"];
    }
    return !("requestFileSystem" in global ||
        "webkitRequestFileSystem" in global || false);
}

function _getVersion(ua, token) { // @ret SemverString - "0.0.0"
    try {
        return _normalizeSemverString(ua.split(token)[1].trim().split(/[^\w\.]/)[0]);
    } catch (o_O) {
        // ignore
    }
    return "0.0.0";
}

function _normalizeSemverString(version) { // @arg String - "Major.Minor.Patch"
    // @ret SemverString - "Major.Minor.Patch"
    var ary = version.split(/[\._]/); // "1_2_3" -> ["1", "2", "3"]
    // "1.2.3" -> ["1", "2", "3"]
    return (parseInt(ary[0], 10) || 0) + "." +
        (parseInt(ary[1], 10) || 0) + "." +
        (parseInt(ary[2], 10) || 0);
}

function getIOSVersion() {
    //if (/iP(hone|od|ad)/.test(navigator.platform)) {
    //    // supports iOS 2.0 and later: <http://bit.ly/TJjs1V>
    //    var v = (navigator.appVersion).match(/OS (\d+_\d+)/);
    //    return parseFloat(v[1].replace('_', '.'));
    //}
    return parseFloat(('' + (/CPU.*OS ([0-9_]{1,5})|(CPU like).*AppleWebKit.*Mobile/i.exec(navigator.userAgent) || [0, ''])[1]).replace('undefined', '3_2').replace('_', '.').replace('_', '')) || false;
}
}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],8:[function(require,module,exports){
var isLocal = getLocal();
var isStaging = getStaging();
var isAdmin = getAdmin();
var domain = getDomain(isLocal, isStaging, isAdmin);
var clientDomain = getDomain(isLocal, isStaging, false);
var adminDomain = getDomain(isLocal, isStaging, false);
var appDomain = getAppDomain(isLocal, isStaging, isAdmin);
var reportDomain = getDomain(isLocal, isStaging, false);
var adminDomain = getDomain(isLocal, isStaging, true);

var stack = isLocal || isStaging ? 'staging' : 'production';

var config = {
    isAdmin: isAdmin,
    domain: domain,
    clientDomain: clientDomain,
    adminDomain: adminDomain,
    appDomain: appDomain,
    reportDomain: reportDomain,
    stack: stack,
    src: {
        firebase: 'https://www.gstatic.com/firebasejs/6.6.2/firebase.js',
        analytics: '//www.google-analytics.com/analytics.js',
    },
    widgets: {
        widgetUrl: appDomain + '/sdk/widgets/{widget}?id={id}',
    },
    firebase: {
        events: getBlunderboreEventsFirebaseConfig(isLocal, isStaging),
        chat: getChatFirebaseConfig(isLocal, isStaging),
        live: getBlunderboreLiveFirebaseConfig(isLocal, isStaging),
    },
    recaptcha: {
        siteKey: '6LdOAKIUAAAAAJCtnneL1ffRBCsHCo_FNuFGcCyi',
        url: 'https://www.google.com/recaptcha/api.js?render=explicit',
    },
    url: {
        configuration: adminDomain + '/configurations',
        //configuration: domain + '/configurations',
        player: domain + '/players/{id}/info',
        accessRules: domain + '/accessrules/{id}',
        refreshToken: domain + '/accessrules/token?key={token}',
        survey: domain + '/accessrules/portal/{id}',
        resource: domain + '/players/{webcastId}/resources/{resourceId}',
        share: {
            facebook: 'http://www.facebook.com/sharer.php?u={url}',
            twitter: 'https://twitter.com/share?url={url}',
            linkedin: 'http://www.linkedin.com/shareArticle?url={url}'
        },
        fireChatToken: domain + '/firebase',
        fireChat: 'https://scorching-fire-2945.firebaseio.com/chat/',
        askAQuestion: 'https://scorching-fire-2945.firebaseio.com/chat/room-messages/{roomId}.json?auth={token}',
        p2pUsage: domain + '/players/{id}/p2p/usage',
        chatHistory: domain + '/players/{id}/chat/history/',
        error: domain + '/report/error',
        viewers: reportDomain + '/players/{id}/report',
        vtt: {
            admin: {
                get: adminDomain + '/players/{id}/vtt/{path}/{language}',
                list: adminDomain + '/players/{id}/vtt/',
            },
            get: domain + '/players/{id}/vtt/{path}/{language}',
            list: domain + '/players/{id}/vtt/',
        },
        auth: {
            token: domain + '/auth/token',
            provider: domain + '/auth/api/{provider}?customerCode={customerCode}&successRedirect={successRedirect}&failureRedirect={failureRedirect}',
            successRedirect: appDomain + '/sdk/auth/identity/callback.html?success&identificationToken={token}',
            failureRedirect: appDomain + '/sdk/auth/identity/callback.html?failure',
        },
        slides: {
            upload: 'https://cwc-thumbs.s3.amazonaws.com/',
            get: 'https://vwsp5tdc06.execute-api.eu-west-1.amazonaws.com/' + stack + '/slides/{webcastId}',
            convert: 'https://vwsp5tdc06.execute-api.eu-west-1.amazonaws.com/' + stack + '/slides/{webcastId}/convert',
            remove: 'https://vwsp5tdc06.execute-api.eu-west-1.amazonaws.com/' + stack + '/slides/{webcastId}/delete',
            uploadCredentialsForm: 'https://vwsp5tdc06.execute-api.eu-west-1.amazonaws.com/' + stack + '/slides/{webcastId}/upload/credentials/form',
        },
        events: {
            admin: {
                list: adminDomain + '/players/{id}/eventsv2/list',
                //get: adminDomain + '/events/{id}',
                //post: adminDomain + '/events',
            },
            list: domain + '/players/{id}/eventsv2/list',
            //get: domain + '/events/{id}',
        },
        rivet: {
            audience: {
                conference: getRivetAudienceConferenceUrl(isLocal, isStaging, isAdmin)
            },
            proxy: '//rivet-proxy-{environment}.companywebcast.com',
        }
    },
    activeResourceViews: ['cwc.legacy.speaker', 'cwc.legacy.form', 'cwc.legacy.slide', 'cwc.legacy.topic'],
    resources: [
        {
            'name': 'speakers',
            'events': {
                'speakers.speaker:activate': true,
                'speakers.speaker:deactivate': false,
                'speakers.hide:deactivate': false,
                'dcnspeakers.speaker:activate': true,
                'dcnspeakers.hide:deactivate': false
            }
        },
        {
            'name': 'topics',
            'events': {
                'index.index:activate': true,
                'index.index:deactivate': false
            }
        },
        {
            'name': 'comments',
            'events': {
                'comments.comment:activate': true,
                'comments.hide:deactivate': false
            }
        },
        {
            'name': 'forms',
            'events': {
                'form.show:activate': true,
                'form.hide:deactivate': false
            }
        },
        {
            name: 'slides',
            events: {
                'slides.slide:activate': true,
                'slides.slide:deactivate': false,
            }
        }
    ],
    cast: {
        applicationId: isLocal || isStaging ? 'C0C9EDFF' : 'CD5FD6DC',
        urn: 'urn:x-cast:cwc.sdk.player',
    },
}

module.exports = config;

function getRivetAudienceConferenceUrl(isLocal, isStaging, isAdmin) {
    var appBaseUrl = (isLocal || isStaging)
        ? 'https://audienceconference.devrivet.net/{eventId}'
        : 'https://idontexistyet.net/{eventId}';

    return appBaseUrl + (isAdmin ? '/participant' : '/attendee');
}

function getDomain(isLocal, isStaging, isAdmin) {
    return '//sdk{admin}{staging}.companywebcast.com'
        .replace('{admin}', isAdmin ? '-admin' : '')
        .replace('{staging}', isLocal || isStaging ? '-staging' : '');
}

function getAppDomain(isLocal, isStaging, isAdmin) {
    if (isLocal) return '//localhost';
    return getDomain(isLocal, isStaging, isAdmin);
}

function getLocal() {
    return false;
}
function getStaging() {
    return false;
}
function getAdmin() {
    return false;
}

function getChatFirebaseConfig(isLocal, isStaging) {
    if (isLocal || isStaging) {
        return {
            token: domain + '/firebase',
            apiKey: "AIzaSyDTVlszjL3F67u0QjsZE6NP4OOpdCXEKbs",
            authDomain: "staging-chat-6c7df.firebaseapp.com",
            databaseURL: "https://staging-chat-6c7df.firebaseio.com",
            projectId: "staging-chat-6c7df",
            storageBucket: "staging-chat-6c7df.appspot.com",
            messagingSenderId: "866129312965",
            appId: "1:866129312965:web:da32e7554d11c1bd"
        }
    }

    return {
        token: domain + '/firebase',
        apiKey: "AIzaSyCkJHYk4uyrxBwtFm6dEoxSwsRO68uRxuU",
        authDomain: "scorching-fire-2945.firebaseapp.com",
        databaseURL: "https://scorching-fire-2945.firebaseio.com",
        projectId: "scorching-fire-2945",
        storageBucket: "scorching-fire-2945.appspot.com",
        messagingSenderId: "789939780219",
        appId: "1:789939780219:web:37a181686cb0fd4a"
    };
}

function getBlunderboreEventsFirebaseConfig(isLocal, isStaging) {
    if (isLocal || isStaging) {
        return {
            token: domain + "/accessrules/firebase/events",
            apiKey: "AIzaSyAoB5iGAGK3HEOH38C6HffCeYwaMEi2bhc",
            authDomain: "blunderbore-live-development.firebaseapp.com",
            databaseURL: "https://blunderbore-live-development.firebaseio.com",
            projectId: "blunderbore-live-development",
            storageBucket: "blunderbore-live-development.appspot.com",
            messagingSenderId: "551303059169"
        }
    }

    return {
        token: domain + "/accessrules/firebase/events",
        apiKey: "AIzaSyB1uBWs6TbIdT85w218DLGLWAjO1PwpKUA",
        authDomain: "blunderbore-live.firebaseapp.com",
        databaseURL: "https://blunderbore-live.firebaseio.com",
        projectId: "blunderbore-live",
        storageBucket: "blunderbore-live.appspot.com",
        messagingSenderId: "896486049217"
    }
}

function getBlunderboreLiveFirebaseConfig(isLocal, isStaging) {
    if (isLocal || isStaging) {
        return {
            apiKey: "AIzaSyAoB5iGAGK3HEOH38C6HffCeYwaMEi2bhc",
            authDomain: "blunderbore-live-development.firebaseapp.com",
            databaseURL: "https://blunderbore-live-development.firebaseio.com",
            projectId: "blunderbore-live-development",
            storageBucket: "blunderbore-live-development.appspot.com",
            messagingSenderId: "551303059169",
            appId: "1:551303059169:web:7f4d4b5944660e76"
        };
    }

    return {
        apiKey: "AIzaSyB1uBWs6TbIdT85w218DLGLWAjO1PwpKUA",
        authDomain: "blunderbore-live.firebaseapp.com",
        databaseURL: "https://blunderbore-live.firebaseio.com",
        projectId: "blunderbore-live",
        storageBucket: "blunderbore-live.appspot.com",
        messagingSenderId: "896486049217",
        appId: "1:896486049217:web:776e4952f6187cb2"
    };

}
},{}],9:[function(require,module,exports){
var api = {
    get: get,
    set: set,
    clear: clear,
    remove: remove,
}

function get(name) {
    var cookies = document.cookie.split('; ');
    for (var i = 0, length = cookies.length; i < length; i++) {
        cookies[i] = cookies[i].split('=', 2);
        if (name == decodeURIComponent(cookies[i][0])) {
            return decodeURIComponent(cookies[i][1]);
        };
    }
    return null;
}

function clear() {
    (function () {
        var cookies = document.cookie.split("; ");
        for (var c = 0; c < cookies.length; c++) {
            var d = window.location.hostname.split(".");
            while (d.length > 0) {
                var cookieBase = encodeURIComponent(cookies[c].split(";")[0].split("=")[0]) + '=; expires=Thu, 01-Jan-1970 00:00:01 GMT; domain=' + d.join('.') + ' ;path=';
                var p = location.pathname.split('/');
                document.cookie = cookieBase + '/';
                while (p.length > 0) {
                    document.cookie = cookieBase + p.join('/');
                    p.pop();
                };
                d.shift();
            }
        }
    })();
}

function set(name, value, options) {
    var cookie = encodeURIComponent(name) + '=' + encodeURIComponent(value);

    for (option in options) {
        switch (option) {
            case 'expires':
                cookie += '; expires=' + (isNaN(options[option]) ? options[option] : addDays(options[option]));
                break;
            case 'secure':
                cookie += '; secure'
                break;
            default:
                cookie += '; ' + option + '=' + options[option];
                break;
        }
    }

    document.cookie = cookie;
    return get(name) == value;
}

function remove(name) {
    return !set(name, '', { expires: -1 });
}

function addDays(days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 86400000);
    return date.toGMTString();
}

module.exports = api;

},{}],10:[function(require,module,exports){
var EventEmitter = require('./EventEmitter');

var eventEmitter = new EventEmitter();
var focusableId = 1;
var tabPressed = false;

var xmlns = "http://www.w3.org/2000/svg";
var skip = ['element', 'attributes', 'style', 'events', 'children', 'textContent', 'innerHTML'];
var visibilityClasses = ['hidden', 'visible', 'hidden-animate', 'visible-animate', 'removed'];
var pairedVisibilityClasses = {
    'hidden': {},
    'visible': {},
    'hidden-animate': {
        'hidden': true,
    },
    'visible-animate': {},
}


var promises = {
    scripts: {},
}

module.exports = {
    fromString: fromString,
    replace: replace,
    create: create,
    createSvg: createSvg,
    hide: hide,
    show: show,
    fadeIn: fadeIn,
    fadeOut: fadeOut,
    focusable: focusable,
    on: eventEmitter.on,
    loadScript: loadScript,
    loadScripts: loadScripts,
}

window.addEventListener('keydown', function (e) {
    if (e.keyCode == 9)
        tabPressed = true;
});

window.addEventListener('keyup', function (e) {
    if (e.keyCode == 9)
        tabPressed = false;
});

function fromString(string) {
    var element = document.createElement('div');
    element.innerHTML = string;
    return element.firstChild;
}

function replace(source, target) {
    try {
        source.parentNode.replaceChild(target, source);
        return target;
    } catch (e) {
        console.log(e);
    }

    return null;
}

function hide(element) {
    setVisibility(element, false, false);
}

function fadeOut(element) {
    setVisibility(element, false, true);
}

function show(element) {
    setVisibility(element, true, false);
}

function fadeIn(element) {
    setVisibility(element, true, true);
}

function setVisibility(element, visible, animate) {
    if (!element.touched) {
        element.touched = true;
        element.addEventListener('webkitAnimationEnd', addRemoveClass);
        element.addEventListener('animationend', addRemoveClass);
    }

    element.visible = visible;
    var className = visible ? 'visible' : 'hidden';
    if (animate) className += '-animate';

    setVisibilityClass(element, className);


    function addRemoveClass() {
        if (!element.visible) {
            element.classList.add('hidden');
            element.blur();
        }
    }
}

function setVisibilityClass(element, className) {
    for (var i = 0, length = visibilityClasses.length; i < length; i++) {
        if (visibilityClasses[i] != className && !pairedVisibilityClasses[className][visibilityClasses[i]]) {
            element.classList.remove(visibilityClasses[i]);
        }
    }
    if (!element.classList.contains(className)) {
        element.classList.add(className);
    }
}



function focusable(element, onFocus, onBlur) {
    element.tabIndex = 0;

    var eventData = {
        id: focusableId++,
    }

    element.addEventListener('focus', function (e) {
        if (tabPressed) {
            element.classList.add('focus-keyboard');
            if (onFocus) onFocus(e);
            eventEmitter.emit('focus', eventData);
        }
    });

    element.addEventListener('blur', function (e) {
        element.classList.remove('focus-keyboard');
        if (onBlur) onBlur(e);
        eventEmitter.emit('blur', eventData);
    });
}

function createSvg(options) {
    return create(options, xmlns);
}

function create(options, namespace) {
    var element;

    namespace ?
        element = document.createElementNS(xmlns, options.element) :
        element = document.createElement(options.element);

    for (var key in options.attributes) {
        var attr = options.attributes[key];
        if (attr !== undefined) {
            namespace ?
                element.setAttributeNS(null, key, options[key]) :
                element.setAttribute(key, attr);
        }
    }

    for (var key in options.events) {
        element.addEventListener(key, options.events[key]);
    }

    for (var key in options.style) {
        element.style[key] = options.style[key];
    }

    if (options.children && options.children.length > 0) {
        for (var i = 0, len = options.children.length; i < len; i++) {
            if (options.children[i]) {
                element.appendChild(options.children[i]);
            }
        }
    }

    for (var key in options) {
        if (skip.indexOf(key) == -1 && options[key] !== undefined) {
            namespace ?
                element.setAttributeNS(null, key, options[key]) :
                element.setAttribute(key, options[key]);
        }
    }

    if (options.textContent) element.textContent = options.textContent;
    if (options.innerHTML) element.innerHTML = options.innerHTML;

    return element;
}

function loadScripts(sources) {
    var promise;

    for(var i = 0; i < sources.length; i++) {
        promise = promiseLoadScript(promise, sources[i]);
    }

    return promise;
}

function promiseLoadScript(promise, src) {
    return promise ? promise.then(function() {
        return loadScript(src);
    }) : loadScript(src);
}

function loadScript(src) {
    var promise = promises.scripts[src];
    if (!promise) {
        promise = new Promise(function (resolve, reject) {
            var el = create({
                element: 'script',
                src: src,
            });

            el.onload = function () { resolve() };
            el.onerror = function (e) { reject(e) };

            document.head.appendChild(el);
        });

        promises.scripts[src] = promise;
    }

    return promise;
}
},{"./EventEmitter":5}],11:[function(require,module,exports){
module.exports = {
    v4: v4,
}

function v4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
};

},{}],12:[function(require,module,exports){
var XmlHttpPromise = require('./http/XmlHttpPromise.js');

module.exports = new Http();

function Http(options) {
    var _this = this;
    options = options || {};

    this.get = get;
    this.head = head;
    this.post = post;
    this.put = put;
    this.auth = auth;
    this.delete = del;
    this.sign = XmlHttpPromise.sign;

    function get(url, params) {
        params = params || {};
        params.method = 'GET';
        params.url = url;
        params.auth = options.auth;
        return new XmlHttpPromise(params);
    }

    function head(url, params) {
        params = params || {};
        params.method = 'HEAD';
        params.url = url;
        params.auth = options.auth;
        return new XmlHttpPromise(params);
    }

    function post(url, data, params) {
        params = params || {};
        params.method = 'POST';
        params.url = url;
        params.data = data;
        params.auth = options.auth;
        return new XmlHttpPromise(params);
    }
    function put(url, data, params) {
        params = params || {};
        params.method = 'PUT';
        params.url = url;
        params.data = data;
        params.auth = options.auth;
        return new XmlHttpPromise(params);
    }

    function del (url, params) {
        params = params || {};
        params.method = 'DELETE';
        params.url = url;
        params.auth = options.auth;
        return new XmlHttpPromise(params);
    }

    function auth(auth) {
        return new Http({ auth: auth });
    }

}
},{"./http/XmlHttpPromise.js":13}],13:[function(require,module,exports){
module.exports = XmlHttpPromise;

function XmlHttpPromise(params) {
    this.params = params;
}

XmlHttpPromise.sign = sign;

XmlHttpPromise.prototype.json = function () {
    if (this.params.data) this.params.data = JSON.stringify(this.params.data);
    this.params.headers = this.params.headers || {};
    this.params.headers['Content-Type'] = 'application/json';

    return requestPromise(this.params).then(function (result) {
        if (result.responseText) {
            return JSON.parse(result.responseText);
        }
    });
}

XmlHttpPromise.prototype.text = function () {
    return requestPromise(this.params).then(function (result) {
        return result.responseText;
    });
}

XmlHttpPromise.prototype.form = function () {
    this.params.headers = this.params.headers || {};

    var str = [];
    for (var p in this.params.data) {
        str.push(encodeURIComponent(p) + "=" + (this.params.data[p] ? encodeURIComponent(this.params.data[p]) : ''));
    }
    this.params.data = str.join("&").replace(/%20/g, '+');
    this.params.headers['Content-Type'] = 'application/x-www-form-urlencoded';

    return requestPromise(this.params).then(function (result) {
        if (result.responseText) {
            return JSON.parse(result.responseText);
        }
    });
}

XmlHttpPromise.prototype.raw = function () {
    return requestPromise(this.params);
}

XmlHttpPromise.getTokenForUrl = getTokenForUrl;

function requestPromise(params) {
    applyAuth(params);
    return applyTransformRequest(params).then(function (params) {
        return new Promise(function (resolve, reject) {

            try {
                var xmlHttp = window.XMLHttpRequest ? new XMLHttpRequest() : new ActiveXObject("Microsoft.XMLHTTP");

                applyQuery(xmlHttp, params);
                xmlHttp.open(params.method, params.url, true);
                if (params.withCredentials) xmlHttp.withCredentials = true;
                applyHeaders(xmlHttp, params);

                xmlHttp.onreadystatechange = function () {
                    if (xmlHttp.readyState == 4) {
                        switch (xmlHttp.status) {
                            case 200:
                            case 204:
                                resolve(xmlHttp);
                                break;
                            default:
                                var response;

                                try {
                                    response = JSON.parse(xmlHttp.responseText);
                                } catch (e) {
                                    response = xmlHttp.response;
                                }

                                reject({
                                    status: xmlHttp.status,
                                    response: response,
                                });
                                break;
                        }
                    }
                }

                xmlHttp.send(params.data);
            } catch (e) {
                reject(e);
            }
        });
    });
}

function getQueryParameters(str) {
    if (str.indexOf('?') == -1) return {};
    return str.replace(/^.*?\?/, '').split("&").map(function (n) { return n = n.split("="), this[n[0]] = decodeURIComponent(n[1]), this }.bind({}))[0];
}

function getUrlWithoutQuery(str) {
    return str.replace(/\?.*/, '');
}

function applyHeaders(xmlHttp, params) {
    if (params.headers) {
        for (var header in params.headers) {
            xmlHttp.setRequestHeader(header, params.headers[header]);
        }
    }
}

function applyQuery(xmlHttp, params) {
    if (!params.query) return;

    var query = getQueryParameters(params.url);
    var url = getUrlWithoutQuery(params.url);

    for (var key in params.query) {
        query[key] = params.query[key];
    }

    var first = true;
    for (var key in query) {

        url = url + (first ? '?' : '&') + key + '=' + query[key]

        first = false;
    }

    params.url = url;
}

function applyTransformRequest(params) {
    if (params.transformRequest) {
        return Promise.resolve(params.transformRequest(params)).then(function () {
            return params;
        });
    }

    return Promise.resolve(params);
}

function applyAuth(params) {
    if (params.auth) {
        var oldTransformRequest = params.transformRequest;

        params.transformRequest = function (params) {
            return params.auth.accessRules.getTokens().then(function (tokens) {
                var token = getTokenForUrl(params.url, params.auth.webcastId, tokens);

                params.headers = params.headers || {};
                params.query = params.query || {};

                if (token) {
                    params.query.Signature = token.Signature;
                    params.query.Policy = token.Policy;
                    params.query['Key-Pair-Id'] = token['Key-Pair-Id'];
                }

                params.headers['X-Authorization'] = tokens.legacyPulseToken;

                if (oldTransformRequest) return oldTransformRequest(params);
            });
        }
    }

    return params;
}

function sign(url, webcastId, tokens) {
    var token = getTokenForUrl(url, webcastId, tokens);
    var first = true;
    if (url.indexOf('?') > -1) {
        first = false;
    }

    for (var key in token) {
        url += first ? '?' : '&';
        url += key + '=' + token[key];
        first = false;
    }
    return url;
}

function getTokenForUrl(url, webcastId, tokens) {
    var t = tokens.cloudFrontTokens[isSecure(url) ? 'ssl' : 'non-ssl'];

    if (url.indexOf('/players') > -1) {
        return t.players;
    } else if (url.indexOf('/playlist') > -1) {
        return t.playlist;
    } else {
        return t[webcastId];
    }
}

function isSecure(url) {
    if (url.indexOf('https://') > -1) return true;
    if (window.location.href.indexOf('https://') > -1) return true;
    return false;
}
},{}],14:[function(require,module,exports){
var cookies = require('./cookies.js');

module.exports = new LocalStorage();

function LocalStorage() {

    var implementation

    try {
        window.localStorage.test = 'test';
        delete window.localStorage.test;
        implementation = new LocalStorageImplementation();
    } catch (e) {
        try {
            cookies.set('test', 'test');
            cookies.remove('test');
            console.warn('localstorage falling back to cookie implementation');
            implementation = new CookieImplementation();
        } catch (e) {
            console.warn('localstorage falling back to dummy implementation');
            implementation = new DummyImplementation();
        }
    }

    this.get = get;
    this.set = set;
    this.setRememberMe = setRememberMe;
    this.clear = clear;

    function setRememberMe(value) {
        implementation.set('rememberme', !!value);
        if (!value) {
            implementation.clear();
        }
    }

    function get(key) {
        var string = implementation.get(key);

        if (string) {
            try {
                return JSON.parse(string);
            } catch (e) {
                console.warn('could not parse string', key, string);
            }
        }

        return null;
    }

    function set(key, value) {
        return implementation.set(key, JSON.stringify(value));
    }

    function clear() {
        return implementation.clear();
    }

    function LocalStorageImplementation() {

        this.get = get;
        this.set = set;
        this.clear = clear;

        function get(key) {
            try {
                return decodeURIComponent(window.localStorage.getItem(key));
            } catch (e) {
                try {
                    return window.localStorage.getItem(key);
                } catch (e) {
                    console.log(e);
                }
            }
        }

        function set(key, value) {
            try {
                return window.localStorage.setItem(key, value);
            } catch (e) {
                console.log(e);
            }
        }

        function clear() {
            try {
                localStorage.clear();
            } catch (e) {
                console.log(e);
            }
        }
    }

    function CookieImplementation() {

        this.get = get;
        this.set = set;
        this.clear = clear;

        function get(key) {
            try {
                return decodeURIComponent(cookies.get(key));
            } catch (e) {
                console.log(e);
            }
        }

        function set(key, value) {
            try {
                return cookies.set(key, encodeURIComponent(value), {
                    expires: 7,
                });
            } catch (e) {
                console.log(e);
            }
        }

        function clear() {
            try {
                cookies.clear();
            } catch (e) {
                console.log(e);
            }
        }
    }

    function DummyImplementation() {
        function doNothing() { }

        this.get = doNothing;
        this.set = doNothing;
        this.clear = doNothing;
    }
}
},{"./cookies.js":9}],15:[function(require,module,exports){
var EventEmitter = require('./EventEmitter.js');
var browserSniffing = require('./browserSniffing.js');
var localStorage = require('./localStorage.js');
var serverTime = require('./serverTime.js');
var guid = require('./guid.js');
var http = require('./http.js');
var config = require('./config.js');

var dom = require('./dom.js');

var level = {
    error: 'error',
    warn: 'warn',
    info: 'info',
}

var eventEmitter = new EventEmitter(true);
var logElement = dom.create({
    element: 'div',
    class: 'log',
    attributes: {
        style: 'z-index:100000;position:absolute;top:0;left:0;background-color:black;color:white',
    }
});

var api = {
    writeToConsole: false,
    level: level,
    on: on,
    error: error,
    warn: warn,
    info: info,
    hijackConsole: hijackConsole,
    sendMetric: sendMetric,
    fingerprint: getFingerprint(),
}

function on(event, callback) {
    return eventEmitter.on(event, callback);
}

function error(message, data) {
    log(level.error, message, data);
    sendMetric(level.error, message, data);
}

function getFingerprint() {
    var fingerprint = localStorage.get('fingerprint');
    if (!fingerprint) {
        fingerprint = guid.v4();
        localStorage.set('fingerprint', fingerprint);
    }
    return fingerprint;
}

function sendMetric(level, message, data) {
    var date = new Date(serverTime()).toISOString();
    var error = {
        level: level,
        message: message,
        data: data,
        fingerprint: api.fingerprint,
        timestamp: date,
        os: browserSniffing.os,
        browser: browserSniffing.browser + ' ' + browserSniffing.browserVersion,
        webview: browserSniffing.webView,
    }

    for (var key in api.scope) {
        error[key] = api.scope[key];
    }
    http.post(config.url.error, error).json();
}

function warn(message, data) {
    log(level.warn, message, data);
    sendMetric(level.warn, message, data);
}

function info(message, data) {
    log(level.info, message, data);
}

function log(level, message, data) {
    var log = {
        level: level,
        message: message,
        data: data,
    }

    eventEmitter.emit('log', log);
    eventEmitter.emit(level, log);

    if (api.writeToConsole && console && console[level]) {
        if (data) {
            console[level](message, data);
        } else {
            console[level](message);
        }
    }
}

function hijackConsole() {
    document.body.appendChild(logElement);
    overwriteConsole('log');
    overwriteConsole('warn');
    overwriteConsole('error');
    overwriteConsole('info');
    overwriteConsole('debug');
    overwriteConsole('trace');

    window.onerror = function () {
        logElement.appendChild(dom.create({
            element: 'pre',
            textContent: JSON.stringify(arguments),
        }));
    }
}

function overwriteConsole(func) {
    var oldFunc = console[func];

    console[func] = function () {
        logElement.appendChild(dom.create({
            element: 'pre',
            textContent: JSON.stringify(arguments, null, ' '),
        }));

        oldFunc.apply(console, arguments);
    }

}


module.exports = api;
},{"./EventEmitter.js":5,"./browserSniffing.js":7,"./config.js":8,"./dom.js":10,"./guid.js":11,"./http.js":12,"./localStorage.js":14,"./serverTime.js":18}],16:[function(require,module,exports){
module.exports = {
    legacy: 'legacy',
    rivetLiveStream: 'RivetLiveStream',
    rivetConference: 'RivetConference',
}
},{}],17:[function(require,module,exports){
var displayOptions = {
    home: 1,
    topics: 2,
    social: 4,
    embed: 8,
    forms: 16,
    askAQuestion: 32,
    controls: 64,    
}

var all = 0;

for (var key in displayOptions) {
    all += displayOptions[key];
}

displayOptions.all = all;

module.exports = displayOptions;
},{}],18:[function(require,module,exports){
var http = require('./http');
var config = require('./config');
module.exports = get;

//var epoch = 0;
var diff = 0;
//var lastTimestamp = performance.now();
//var currentTimestamp = performance.now();

getTimeFromServer();

function getTimeFromServer() {
    var url = config.domain + '/time/now';

    http.get(url).json().then(function (result) {
        //lastTimestamp = performance.now();
        //currentTimestamp = performance.now();
        diff = result.epoch - new Date().getTime();
        console.log('serverTime offset', diff);
    });
}

function get() {
    return new Date().getTime() + diff;
}




},{"./config":8,"./http":12}]},{},[1]);
